// English translations
export const en = {
  // Common
  common: {
    save: 'SAVE',
    close: 'CLOSE',
    cancel: 'CANCEL',
    delete: 'DELETE',
    edit: 'EDIT',
    add: 'ADD',
    complete: 'Complete',
    completed: 'COMPLETED',
    done: 'Done',
    create: 'CREATE',
    loading: 'Loading...',
    settings: 'SETTINGS',
    level: 'Level',
    profile: 'PROFILE',
    step: 'Step',
    of: 'of',
    back: 'BACK',
    next: 'NEXT',
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    quests: 'Quests',
    stats: 'Stats',
    achievements: 'Achievements',
    shop: 'Shop',
    history: 'History',
    calendar: 'Calendar',
    focus: 'Focus',
    passiveSkills: 'Passive Skills',
    settings: 'Settings',
    signOut: 'Sign Out',
  },

  // Dashboard
  dashboard: {
    title: 'HUNTER DASHBOARD',
    subtitle: 'Track your progress and complete quests',
    systemStatus: 'System Status',
    name: 'Name:',
    class: 'Class:',
    streak: 'Streak',
    best: 'Best:',
    currency: 'Currency',
    level: 'Level',
    xp: 'XP',
    createQuest: 'Create Quest',
    aiGenerator: 'AI Quest Generator',
    createProgram: 'AI Training Program',
    dailyQuests: 'Daily Quests',
    activeQuests: 'Active Quests',
    scheduledQuests: 'Scheduled Quests',
    noQuests: 'No quests available',
    noQuestsDesc: 'Create your first quest to begin your journey!',
  },

  // Quests
  quests: {
    title: 'Quest Title',
    description: 'Description',
    titlePlaceholder: 'Enter quest title...',
    descriptionPlaceholder: 'Quest details...',
    questType: 'QUEST TYPE',
    difficulty: 'DIFFICULTY',
    schedule: 'SCHEDULE FOR (OPTIONAL)',
    scheduleDesc: 'Leave empty for immediate availability or select a future date',
    subTasks: 'SUB-TASKS / CHECKLIST (OPTIONAL)',
    addSubTask: 'Add a sub-task...',
    enhanced: 'Enhanced',
    rewards: 'Rewards',
    status: 'Status',
    main: 'Main',
    side: 'Side',
    daily: 'Daily',
    boss: 'Boss',
    instant: 'Instant',
  },

  // Quest Edit Modal
  questEdit: {
    questDetails: 'Quest Details',
    completed: 'COMPLETED',
    close: 'Close',
    questTitle: 'Quest Title',
    noDescription: 'No description',
    calendarColor: 'Calendar Color',
    scheduledTime: 'Scheduled Time',
    startTime: 'Start Time',
    endTime: 'End Time',
    rewards: 'Rewards',
    willUpdateOnSave: 'Will update on save',
    xp: 'XP',
    gold: 'Gold',
    stats: 'Stats',
    cancel: 'Cancel',
    saveChanges: 'Save Changes',
    complete: 'Complete',
    edit: 'Edit',
    delete: 'Delete',
    confirmDelete: 'Are you sure you want to delete this quest?',
    dailyReset: 'Daily Reset',
    resetDaily: 'Reset this quest daily',
    resetDailyDescription: 'Quest will reset to active status each day after completion',
    oneTimeDescription: 'Quest will remain completed once finished',
    dailyResetStatus: 'Resets daily',
    oneTimeStatus: 'One-time quest',
    dailyResetTooltip: 'Perfect for daily habits and routines',
    oneTimeTooltip: 'Great for one-time tasks and projects',
    colorTooltip: 'Choosing "Default" will use the quest type color automatically',
    colors: {
      default: 'Default (Type)',
      shadowBlue: 'Shadow Blue',
      monarchPurple: 'Monarch Purple',
      emeraldGreen: 'Emerald Green',
      bloodRed: 'Blood Red',
      goldMonarch: 'Gold Monarch',
      iceCrystal: 'Ice Crystal',
      pinkMagic: 'Pink Magic',
      darkVoid: 'Dark Void',
    },
  },

  // Difficulty levels
  difficulty: {
    easy: 'E-Rank (Easy)',
    normal: 'C-Rank (Normal)',
    hard: 'A-Rank (Hard)',
    veryHard: 'A-Rank (Very Hard)',
    boss: 'S-Rank (Boss)',
  },

  // Settings
  settings: {
    title: 'SETTINGS',
    subtitle: 'Customize your hunter experience',
    profile: 'PROFILE',
    preferences: 'PREFERENCES',
    appearance: 'APPEARANCE',
    account: 'ACCOUNT',
    save: 'SAVE',
    replayTutorial: 'Replay Tutorial',
    replayTutorialDesc: 'Restart the onboarding guide',
    playerName: 'Player Name',
    namePlaceholder: 'Enter your name...',
    title_label: 'Title',
    audio: 'AUDIO',
    masterAudio: 'Master Audio',
    masterAudioDesc: 'Enable/disable all sounds',
    systemVoice: 'System Voice',
    systemVoiceDesc: 'Epic voice lines for achievements',
    voiceVolume: 'Voice Volume',
    voiceVolumeDesc: 'Adjust voice line volume',
    sfxVolume: 'Sound Effects Volume',
    sfxVolumeDesc: 'Adjust UI and action sound effects',
    backgroundMusic: 'Background Music',
    backgroundMusicDesc: 'Enable ambient music while using the app',
    musicTheme: 'Music Theme',
    musicThemeDesc: 'Select your background music',
    musicVolume: 'Music Volume',
    musicVolumeDesc: 'Adjust background music volume',
    test: 'TEST',
    gameplay: 'GAMEPLAY',
    xpMultiplier: 'XP Multiplier',
    xpMultiplierDesc: 'Adjust experience gain rate',
    hard: '(Hard)',
    normal: '(Normal)',
    easy: '(Easy)',
    theme: 'THEME WALLPAPER',
    themeDesc: 'Select a background theme inspired by Solo Leveling',
    language: 'LANGUAGE',
    languageDesc: 'Select your preferred language',
    english: 'English',
    russian: 'Russian',
    howItWorks: 'How it works:',
    howItWorksDesc: 'The selected theme will be applied as the background throughout the entire app with matching color schemes.',
    addImagesDesc: 'Add your Solo Leveling images to',
    addImagesDesc2: 'folder with names like:',
    settingsSaved: 'Settings Saved!',
  },

  // Programs
  programs: {
    title: 'AI TRAINING PROGRAMS',
    subtitle: 'Structured learning paths generated by AI',
    activePrograms: 'Active Programs',
    noPrograms: 'No active programs',
    noProgramsDesc: 'Create an AI-powered training program to start!',
    createProgram: 'Create Program',
    viewRoadmap: 'View Roadmap',
    pause: 'Pause',
    resume: 'Resume',
    delete: 'Delete',
    progress: 'Progress',
    duration: 'Duration',
    days: 'days',
    questsCompleted: 'Quests Completed',
  },

  // AI Generator Selector
  aiSelector: {
    title: 'AI GENERATOR',
    subtitle: 'Choose your AI-powered productivity tool',
    questGenerator: {
      title: 'Quest Generator',
      description: 'Generate individual quests instantly using AI. Perfect for quick task creation with smart suggestions and resources.',
      useCase: 'Best for: Creating 1-5 standalone quests',
    },
    programGenerator: {
      title: 'Training Program',
      description: 'Create comprehensive multi-week training programs with daily scheduled quests. AI designs a complete learning path tailored to your goals.',
      useCase: 'Best for: Long-term goals requiring structured planning',
    },
    footer: '',
  },

  // AI Generator
  aiGenerator: {
    questTitle: 'AI QUEST GENERATOR',
    questSubtitle: 'Let AI create personalized quests for you',
    programTitle: 'CREATE AI TRAINING PROGRAM',
    programSubtitle: 'AI-powered personalized roadmap',
    yourGoal: 'What would you like to accomplish?',
    goalPlaceholder: 'E.g., Learn JavaScript, Build a portfolio, Get fit...',
    questType: 'Quest Type',
    numberOfQuests: 'Number of Quests',
    generate: 'GENERATE QUESTS',
    generating: 'GENERATING...',
    generated: 'AI-Generated Quests',
    selected: 'selected',
    generateNew: 'Generate New',
    acceptSelected: 'ACCEPT SELECTED',
    configureAPI: 'Configure API Key in Settings',
    error: 'Failed to generate. Check API key.',
    // Program creation
    programGoal: 'Program Goal',
    programGoalPlaceholder: 'E.g., Master Python, Learn Guitar, Build Fitness Routine...',
    programDuration: 'Program Duration (Days)',
    scheduleType: 'Schedule Type',
    scheduleDaily: 'Daily',
    scheduleWeekly: 'Weekly',
    scheduleCustom: 'Custom',
    customDays: 'Custom Days',
    questsPerDay: 'Quests Per Day',
    intensity: 'Intensity Level',
    intensityLight: 'Light',
    intensityModerate: 'Moderate',
    intensityIntense: 'Intense',
    personalization: 'PERSONALIZATION (OPTIONAL)',
    skillLevel: 'Your Current Skill Level',
    skillBeginner: 'Beginner',
    skillIntermediate: 'Intermediate',
    skillAdvanced: 'Advanced',
    timePerDay: 'Time Available Per Day',
    learningStyle: 'Preferred Learning Style',
    learningStylePlaceholder: 'E.g., Hands-on projects, Reading documentation, Video tutorials...',
    specificFocus: 'Specific Focus/Goals',
    specificFocusPlaceholder: 'E.g., Focus on web development, build a portfolio project...',
    availableResources: 'Available Resources',
    availableResourcesPlaceholder: 'E.g., Have a guitar, laptop, gym membership...',
    generateProgram: 'GENERATE PROGRAM',
    generatingProgram: 'GENERATING PROGRAM...',
    programCreating: 'Creating your personalized training roadmap...',
    // Step 1
    whatsYourGoal: "What's Your Goal?",
    goalMin: 'Please enter a goal (min 4 characters) and select at least 7 days duration.',
    characters: 'characters',
    weeks: 'weeks',
    week: 'week',
    year: 'year',
    // Step 2
    trainingSchedule: 'Training Schedule',
    schedEveryDay: 'Every Day',
    schedEveryDayDesc: 'Maximum progress',
    sched5xWeek: '5x per Week',
    sched5xWeekDesc: 'Weekdays only',
    sched3xWeek: '3x per Week',
    sched3xWeekDesc: 'Mon / Wed / Fri',
    sched2xWeek: '2x per Week',
    sched2xWeekDesc: 'Tue / Thu',
    schedEveryOther: 'Every Other Day',
    schedEveryOtherDesc: 'Alternating days',
    schedWeekends: 'Weekends Only',
    schedWeekendsDesc: 'Sat / Sun',
    schedCustom: 'Custom Schedule',
    schedCustomDesc: 'Pick specific days',
    selectActiveDays: 'Select active days:',
    minutes: 'minutes',
    intensityDesc: {
      light: '15-20 min/day, gentle pace',
      moderate: '30-45 min/day, steady progress',
      intense: '60-90 min/day, rapid advancement',
    },
    // Step 3
    personalizeJourney: 'Personalize Your Journey',
    personalizeDesc: 'Help our AI create the perfect roadmap with resources, examples, and tips tailored just for you!',
    currentSkillLevel: 'Current Skill Level',
    learningStyleOptional: 'Learning Style (Optional)',
    specificFocusOptional: 'Specific Focus (Optional)',
    availableResourcesOptional: 'Available Resources (Optional)',
    availableResourcesPlaceholder2: 'e.g., I have access to Duolingo, textbooks, or specific tools...',
    specificFocusPlaceholder2: 'e.g., Speaking skills, grammar fundamentals, project-based...',
  },

  // Focus Timer
  focus: {
    title: 'FOCUS TIMER',
    subtitle: 'Stay focused and earn rewards',
    work: 'WORK',
    break: 'BREAK',
    focusTime: 'Focus Time',
    breakTime: 'Break Time',
    start: 'START',
    pause: 'PAUSE',
    reset: 'RESET',
    rewardsPerSession: 'Rewards per Session',
  },

  // Achievements
  achievements: {
    title: 'ACHIEVEMENTS',
    subtitle: 'Your hunter accomplishments',
    unlocked: 'Unlocked',
    locked: 'Locked',
    progress: 'Progress',
    all: 'All',
    combat: 'Combat',
    progression: 'Progression',
    special: 'Special',
  },

  // Shop
  shop: {
    title: 'SHOP',
    subtitle: 'Spend your hard-earned currency',
    balance: 'Your Balance',
    themes: 'Themes',
    titles: 'Titles',
    owned: 'OWNED',
    equip: 'EQUIP',
    equipped: 'EQUIPPED',
    purchase: 'PURCHASE',
    notEnough: 'Not enough gold!',
  },

  // Notifications
  notifications: {
    questComplete: 'Quest completed!',
    levelUp: 'Level up!',
    achievementUnlocked: 'Achievement unlocked!',
    programCreated: 'Program created!',
    penaltyWarning: 'Daily quest penalty!',
    dailyReward: 'Daily reward claimed!',
  },

  // History
  history: {
    title: 'QUEST HISTORY',
    subtitle: 'Your completed and failed quests',
    completedQuests: 'Completed Quests',
    noHistory: 'No quest history yet',
    completedOn: 'Completed on',
    earnedRewards: 'Earned Rewards',
    currentCurrency: 'Current Currency',
    earned: 'Earned',
    bossDefeated: 'Boss Defeated',
    byDifficulty: 'BY DIFFICULTY',
    byType: 'BY TYPE',
  },

  // Stats
  stats: {
    title: 'STATISTICS',
    subtitle: 'Track your productivity journey',
    days7: '14 DAYS',
    days30: '30 DAYS',
    level: 'Level',
    quests: 'Quests',
    totalXP: 'Total XP',
    currentCurrency: 'Current Currency',
    earnedFromQuests: 'Earned from quests:',
    hunterStatsAnalysis: 'HUNTER STATS ANALYSIS',
    systemInterface: '［ System Interface ］',
    xpProgression: 'XP PROGRESSION',
    questActivity: 'QUEST ACTIVITY',
    focusDuration: 'FOCUS DURATION',
    wealthAccumulation: 'WEALTH ACCUMULATION',
    // Player stats
    strength: 'STRENGTH',
    intelligence: 'INTELLIGENCE',
    agility: 'AGILITY',
    vitality: 'VITALITY',
    sense: 'SENSE',
    allocate: 'ALLOCATE STATS',
    allocateDesc: 'Complete quests to earn stat points',
    unallocated: 'Unallocated Points',
    completed: 'Completed',
    failed: 'Failed',
    streak: 'Day Streak',
  },

  // Onboarding
  onboarding: {
    intro: {
      title: 'SYSTEM INITIALIZATION',
      message: 'Greetings, Player. The System has chosen you to embark on a journey of self-improvement. Complete quests, level up your stats, and become the ultimate version of yourself. Your transformation begins now...',
      skip: 'Skip Introduction',
    },
    steps: {
      stats: {
        title: 'Your Hunter Stats',
        description: 'Monitor your level, XP progress, and character attributes. Complete quests to earn XP and level up. Allocate stat points to strengthen your abilities: STR, INT, AGI, VIT, and SNS.',
      },
      quests: {
        title: 'Quest System',
        description: 'Create quests manually or use AI generation. Quest types: Daily (reset daily), Main (important goals), Instant (quick tasks), and Boss (ultimate challenges). Each has different difficulty ranks from E to S.',
      },
      aiGenerator: {
        title: 'AI-Powered Tools',
        description: 'Let AI help you! Quest Generator creates individual tasks instantly. Training Program builds comprehensive multi-week learning paths. Perfect for when you need smart suggestions.',
      },
      sidebar: {
        title: 'Navigation Hub',
        description: 'Access all features: Focus Timer for Pomodoro sessions, Calendar for activity tracking, Statistics for progress analysis, History for completed quests, Achievements, Shop, and Settings.',
      },
      level: {
        title: 'Level & Currency',
        description: 'Track your Hunter Rank and level progress. Earn currency by completing quests to unlock shop items and customize your experience.',
      },
    },
    actions: {
      skip: 'Skip Tutorial',
      finish: 'Start Your Journey',
    },
  },

  // Calendar
  calendar: {
    title: 'ACTIVITY CALENDAR',
    subtitle: 'Track your productivity journey',
    currentStreak: 'Current Streak',
    longestStreak: 'Longest Streak',
    thisMonth: 'This Month',
    days: 'days',
    prev: 'PREV',
    next: 'NEXT',
    less: 'Less',
    more: 'More',
    active: 'Active',
    scheduled: 'Scheduled',
    completed: 'Completed',
    failed: 'Failed',
    quests: 'Quests',
    xpEarned: 'XP Earned',
    currency: 'Currency',
    focusMin: 'Focus (min)',
    noActivity: 'No activity on this day',
    weekDays: {
      sun: 'Sun',
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat',
    },
    weekDaysFull: {
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
    },
    weekDaysShort: {
      sun: 'S',
      mon: 'M',
      tue: 'T',
      wed: 'W',
      thu: 'T',
      fri: 'F',
      sat: 'S',
    },
    monthsShort: {
      jan: 'Jan',
      feb: 'Feb',
      mar: 'Mar',
      apr: 'Apr',
      may: 'May',
      jun: 'Jun',
      jul: 'Jul',
      aug: 'Aug',
      sep: 'Sep',
      oct: 'Oct',
      nov: 'Nov',
      dec: 'Dec',
    },
    monthsFull: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
    month: 'Month',
    week: 'Week',
    day: 'Day',
    backToMonth: 'Back to Month',
    selectDayFirst: 'Please select a day from month view first',
    viewToday: 'View Today',
    unscheduledQuests: 'Unscheduled Quests',
  },

  // Passive Skills
  passiveSkills: {
    title: 'PASSIVE SKILLS',
    subtitle: 'Build lasting habits to unlock permanent stat boosts',
    newSkill: '+ New Skill',
    activeBoosts: 'Active Passive Boosts',
    filter: 'Filter:',
    showPaused: 'Show Paused',
    loading: 'Loading your passive skills...',
    noSkills: 'No Passive Skills Yet',
    noSkillsCategory: 'No {category} skills found. Try a different category or create a new skill.',
    noSkillsDesc: 'Start building lasting habits by creating your first passive skill!',
    createFirst: 'Create Your First Skill',
    // Categories
    all: 'All',
    physical: 'Physical',
    mental: 'Mental',
    social: 'Social',
    spiritual: 'Spiritual',
    productivity: 'Productivity',
    // Card
    paused: 'Paused',
    level: 'Level',
    max: 'MAX',
    streak: 'Streak',
    best: 'Best:',
    total: 'Total:',
    boost: 'Boost',
    thisWeek: 'This Week',
    completionHistory: 'Completion History',
    complete: '✓ Complete',
    doneToday: '✓ Done Today',
    notScheduledToday: 'Not scheduled today',
    pause: '⏸️ Pause',
    resume: '▶️ Resume',
    deleteSkill: '🗑️ Delete',
    // Create Modal
    createSkill: 'Create Passive Skill',
    buildHabit: 'Build a new lasting habit',
    skillName: 'Skill Name *',
    skillNamePlaceholder: 'e.g., Morning Meditation, Daily Workout...',
    description: 'Description',
    descriptionPlaceholder: 'Describe your habit and why it matters...',
    category: 'Category *',
    icon: 'Icon *',
    iconPlaceholder: 'Enter emoji',
    frequency: 'Frequency *',
    daily: 'Daily (Every day)',
    weekly: 'Weekly (Custom days per week)',
    custom: 'Custom Days (Pick weekdays)',
    targetDaysPerWeek: 'Target Days Per Week',
    customDays: 'Select Days of Week',
    customDaysHelp: 'Only completions on selected weekdays count toward weekly goals',
    statBoost: 'Stat to Boost *',
    statBoostDesc: 'Choose which stat this habit will improve. You\'ll earn passive boosts as you level up.',
    howItWorks: 'How Passive Skills Work',
    howItWorksDesc1: '• Complete your habit daily to build streaks and level up (1-10)',
    howItWorksDesc2: '• Higher levels unlock stronger passive stat boosts (+0.5% → +10%)',
    howItWorksDesc3: '• Earn XP, gold, and stat points at major milestones',
    howItWorksDesc4: '• Passive boosts are always active and stack with other skills',
    createButton: 'Create Skill',
    // Milestone Modal
    milestoneReached: 'Milestone Reached!',
    dayStreak: '{value}-Day Streak!',
    levelReached: 'Level {value} Reached!',
    completions: '{value} Completions!',
    rewards: '🎁 Rewards',
    xp: 'XP',
    gold: 'Gold',
    statPoints: 'Stat Points',
    newTitle: 'New Title Unlocked',
    claimRewards: 'Claim Rewards',
    theSystem: '— THE SYSTEM',
    // Motivational messages
    streakMessages: [
      'Consistency is the key to greatness. Keep pushing forward!',
      'Your dedication is remarkable. The System is watching.',
      'Every day brings you closer to mastery. Never give up.',
      'True strength comes from unwavering commitment.',
      'The path of a hunter is built one day at a time.',
    ],
    levelMessages: [
      'You\'ve grown stronger. Your passive skill has evolved.',
      'Power increase detected. Continue your training.',
      'Level up! Your discipline shapes your destiny.',
      'The System recognizes your progress. Well done, Hunter.',
      'With each level, you become more formidable.',
    ],
    totalMessages: [
      'Remarkable persistence. You\'ve completed another milestone.',
      'Your commitment is unwavering. The rewards reflect your effort.',
      'Completion after completion, you build your legacy.',
      'The System has recorded your achievements. They will not be forgotten.',
      'Each completion is a step toward becoming legendary.',
    ],
    // Delete confirmation
    deleteConfirm: 'Are you sure you want to delete this passive skill? This action cannot be undone.',
  },
};

export type TranslationKeys = typeof en;

